import { STORAGE_TYPE, STORAGE_USE_EXPIRES } from '@/settings/projectSetting'
import { BaseStorage } from './webStorage'

export const storageProxy = new BaseStorage(STORAGE_TYPE, STORAGE_USE_EXPIRES)
